/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  responseTime: 0,
  isError: false,
  msgError: '',
};
export const exportHistoryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.EXPORT_HISTORY + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.EXPORT_HISTORY + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        responseTime: action.result.responseTime,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.EXPORT_HISTORY + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    default:
      return state;
  }
};
